module.exports = __webpack_public_path__ + "static/media/tutorial-card-4.2b06d7c6.png";